import { gql } from "@apollo/client";

export const InstalledBaseEventById = gql`
    query InstalledBaseEventById($eventId: ID!) {
        installedBaseEvent(eventId: $eventId) {
            eventType
            eventCategory
            id
            insert
            message
            user {
                id
                name
            }
            asset {
                id
            }
            assetLocation {
                id
            }
            installedBaseNode {
                id
                pathNodes {
                    id
                    title
                    nodeType {
                        key
                    }
                }
            }
            data
            # Only on InstalledBaseEvent - the query returns EventInterface (IBM-1062)
            ... on InstalledBaseEvent {
                attributeList {
                    attributes {
                        id
                        property {
                            id
                            alias
                            preferredName
                        }
                        value
                        displayValue
                    }
                }
                fileList {
                    installedBaseNodeFiles {
                        id
                        insert
                        filename
                        category
                        file {
                            id
                            basename
                            contentType
                            size
                            link
                            thumbnailLink(crop: crop, w: 320, h: 320)
                        }
                        access {
                            id
                            read
                            write
                            delete
                        }
                        ... on InstalledBaseNodeFile {
                            comment
                        }
                    }
                }
            }
        }
    }
`;
